/**
 * Catalog requisite text for the expanded course card.
 *
 * Renders the catalog's own wording (prerequisites_raw / corequisites_raw /
 * restriction) rather than the parsed prerequisite tree: the parsed form the
 * optimizer uses drops grade minimums ("Minimum grade of C- in ...") and
 * non-course alternatives ("or permission of the department"), which are
 * exactly what a student reading the card needs.
 */

export interface CourseRequisitesProps {
  prerequisites?: string | null;
  corequisites?: string | null;
  restriction?: string | null;
}

const clean = (text?: string | null): string | null => {
  const trimmed = typeof text === 'string' ? text.trim() : '';
  return trimmed.length > 0 ? trimmed : null;
};

const CourseRequisites = ({ prerequisites, corequisites, restriction }: CourseRequisitesProps) => {
  const prereq = clean(prerequisites);
  const coreq = clean(corequisites);
  const restr = clean(restriction);

  if (!prereq && !coreq && !restr) return null;

  return (
    <dl className="mb-2 space-y-1.5 text-xs" data-testid="course-requisites">
      {prereq && (
        <div>
          <dt className="text-ink-2">Prerequisites:</dt>
          <dd className="text-ink break-words">{prereq}</dd>
        </div>
      )}
      {coreq && (
        <div>
          <dt className="text-ink-2">Corequisites:</dt>
          <dd className="text-ink break-words">{coreq}</dd>
        </div>
      )}
      {restr && (
        <div>
          <dt className="text-ink-3">Restrictions:</dt>
          <dd className="text-ink-3 break-words">{restr}</dd>
        </div>
      )}
    </dl>
  );
};

export default CourseRequisites;
